(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("cropped-geotiff-elevation", [], factory);
	else if(typeof exports === 'object')
		exports["cropped-geotiff-elevation"] = factory();
	else
		root["cropped-geotiff-elevation"] = factory();
})(self, function() {
return 